var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99407 7.00773C6.60354 7.39826 6.60354 8.03142 6.99407 8.42195L10.5792 12.0071L6.99407 15.5923C6.60354 15.9828 6.60354 16.616 6.99407 17.0065C7.38459 17.397 8.01776 17.397 8.40828 17.0065L11.9934 13.4213L15.5786 17.0065C15.9691 17.397 16.6023 17.397 16.9928 17.0065C17.3833 16.616 17.3833 15.9828 16.9928 15.5923L13.4076 12.0071L16.9928 8.42196C17.3833 8.03144 17.3833 7.39827 16.9928 7.00775C16.6022 6.61722 15.9691 6.61722 15.5786 7.00775L11.9934 10.5929L8.40828 7.00773C8.01776 6.61721 7.38459 6.61721 6.99407 7.00773Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconSvg);
export default __webpack_public_path__ + "static/media/cross-icon-svg.acc765c83d9dbf6a2c4e1922691fd5e2.svg";
export { ForwardRef as ReactComponent };